import React from 'react'
import {
  BriefcaseIcon,
  DocumentIcon,
  NationalIdIcon,
  PencilIcon,
  StackIcon,
  StatementsIcon,
  TransportIcon,
} from '../../components'

export const conditionIconListData = {
  title: 'Conditions title',
  items: [
    {
      icon: <BriefcaseIcon />,
      text: 'Conditions Service Period',
      boldedText: 'Instant Conditions Service Period bold text',
    },
    {
      icon: <StackIcon />,
      text: 'Conditions Salary',
      boldedText: 'Conditions Salary bold text',
    },
    {
      icon: <PencilIcon />,
      text: 'Conditions fill out',
    },
  ],
  footerText: 'Condition footer text',
}

export const requiredIconListData = {
  title: 'Req document Title',
  items: [
    {
      icon: <DocumentIcon />,
      text: 'Req document Salary Certificate',
    },
    {
      icon: <NationalIdIcon />,
      text: 'Req document Valid National',
    },
    {
      icon: <StatementsIcon />,
      text: 'Req document Account statement',
      boldedText: 'Req document Account statement bold text',
    },
    {
      icon: <TransportIcon />,
      text: 'Req document license',
    },
  ],
  footerText: 'Req document footer text',
}

export const conditionIconListDataPersonalInstant = {
  title: 'Conditions title',
  items: [
    {
      icon: <BriefcaseIcon />,
      text: 'Conditions Service Period',
      boldedText: 'Instant Conditions Service Period bold text',
    },
    {
      icon: <StackIcon />,
      text: 'Conditions Salary',
      boldedText: 'Instant Conditions PF Std Salary bold text',
    },
    {
      icon: <PencilIcon />,
      text: 'Conditions fill out',
    },
  ],
  footerText: 'Condition footer text',
}

export const conditionIconListDataPersonalStandard = {
  title: 'Conditions title',
  items: [
    {
      icon: <BriefcaseIcon />,
      text: 'Conditions Service Period',
      boldedText: 'Standard Conditions Service Period bold text',
    },
    {
      icon: <StackIcon />,
      text: 'Conditions Salary',
      boldedText: 'Standard Conditions PF Std Salary bold text',
    },
    {
      icon: <PencilIcon />,
      text: 'Conditions fill out',
    },
  ],
  footerText: 'Condition footer text',
}

export const selfEmployedConditionIconListData = {
  title: 'Self Employed Conditions title',
  items: [
    {
      icon: <BriefcaseIcon />,
      text: 'Self Employed Conditions Est Age',
      boldedText: 'Self Employed Conditions Est Age bold text',
    },
    {
      icon: <NationalIdIcon />,
      text: 'Self Employed Conditions Age',
      boldedText: 'Self Employed Conditions Age bold text',
    },
    {
      icon: <StackIcon />,
      text: 'Self Employed Conditions Salary Bank Statement',
      boldedText: 'Self Employed Conditions Salary Bank Statement bold text',
    },
  ],
  footerText: 'SE Condition footer text',
}

export const requiredIconListSelfEmployedData = {
  title: 'Req document Title',
  items: [
    {
      icon: <DocumentIcon />,
      text: 'Req document Commercial Registration',
    },
    {
      icon: <DocumentIcon />,
      text: 'Req document VAT Certificate',
    },
    {
      icon: <DocumentIcon />,
      text: 'Req document GOSI Certificate',
    },
  ],
  footerText: 'SE Req document footer text',
}

export const requiredIconListDataPersonalInstant = {
  title: 'Req document Title',
  items: [
    {
      icon: '',
      text: 'Req document None',
    },
    {
      icon: '',
      text: '',
    },
    {
      icon: '',
      text: '',
    },
  ],
  footerText: 'Req document footer text',
}

export const requiredIconListDataPersonalStandard = {
  title: 'Req document Title',
  items: [
    {
      icon: <StatementsIcon />,
      text: 'Req document Account statement',
      boldedText: 'Req document Account statement bold text',
    },
  ],
  footerText: 'Req document footer text',
}
